import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init({
  duration: 1500,
});
